export default __webpack_public_path__ + "static/underline-best-e5b02ad60b13bab95d02e691da5b2be3.svg";